module.exports = __webpack_public_path__ + "static/team@2x-a6dec667f3dd99725bc07bdba8f1172d.png";